<div class="col-md-12 mt-3">
    <div class="overflow-auto w-100">
        <div class="float-end">
            <button mat-raised-button color="primary" (click)="openDialogUsersCreate()" class="mt-2 mb-2">
                Agregar grupo <mat-icon>person_add</mat-icon>
            </button>
        </div>
        <mat-form-field>
            <mat-label>
                <mat-icon>search</mat-icon> Buscar</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Ej. Administración" #input>
        </mat-form-field>
    </div>

    <div class="mat-elevation-z8 table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100">

            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
            </ng-container>

            <ng-container matColumnDef="tipo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo </th>
                <td mat-cell *matCellDef="let row"> {{getRol(row.tipo)}} </td>
            </ng-container>

            <ng-container matColumnDef="nombre">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
                <td mat-cell *matCellDef="let row"> {{row.nombre}} </td>
            </ng-container>

            <ng-container matColumnDef="permisos">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Permisos </th>
                <td mat-cell *matCellDef="let row"> {{row.permissions.length }} </td>
            </ng-container>

            <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha creación</th>
                <td mat-cell *matCellDef="let row"> {{row.created_at  | date:'dd/MM/yyyy':"+0000" }} </td>
            </ng-container>


            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center" [hidden]="!hasPermissions('upd_grp',true,null)"> Acciones </th>
                <td mat-cell *matCellDef="let row" class="text-center" [hidden]="!hasPermissions('upd_grp',true,null)">
                    <button mat-icon-button matTooltip="Editar" [matTooltipPosition]="'above'" (click)="openDialogUsersEdit(row)" color="accent">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button  mat-icon-button matTooltip="Eliminar" [matTooltipPosition]="'above'" color="warn" (click)="deleteUser(row.id)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="6">No existe información que coincida con "{{input.value}}"</td>
            </tr>
        </table>

        <div *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center; background: white;">
            <mat-progress-spinner color="primary" mode="indeterminate">
            </mat-progress-spinner>
        </div>
        <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
    </div>
</div>